import React from "react";
import { Container } from "@material-ui/core";
import InvitesTable from "./InvitesTable";
import InvitesOverview from "./InvitesOverview";
import InvitesFilterBar from "./InvitesFilterBar";

const InvitesContainer = () => {
  return (
    <Container>
      <InvitesOverview />
      <InvitesFilterBar />
      <InvitesTable />
    </Container>
  );
};

export default InvitesContainer;
